import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import "../../../Styles/components/pending-approval-state.scss";

export const BSL_PENDING_APPROVAL_STATE = Object.freeze({
  title: "Pending approval",
  message: "Your BSL balance request is being reviewed.",
  icon: faClock,
});

export const BSL_APPLY_IBAN_STATE = Object.freeze({
  title: "Link your BSL Account",
  message: "Link your BSL bank account.",
  icon: null,
});

export default function PendingApprovalState({
  action = null,
  blurred = true,
  children,
  className = "",
  icon = faClock,
  message,
  title,
}) {
  const rootClassName = [
    "new-pending-approval-state",
    blurred ? "is-blurred" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClassName}>
      <div className="new-pending-approval-state__backdrop">{children}</div>

      <div className="new-pending-approval-state__overlay">
        <div className="new-pending-approval-state__content">
          {icon ? (
            <span className="new-pending-approval-state__icon" aria-hidden="true">
              <FontAwesomeIcon icon={icon} />
            </span>
          ) : null}

          <div className="new-pending-approval-state__copy">
            <strong>{title}</strong>
            <p>{message}</p>
          </div>

          {action ? (
            <div className="new-pending-approval-state__action">{action}</div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
